export const selectFlatRateOffersProductFamily = state => state.data.flatRateOffers.selectedProduct;
